var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUserAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_user_account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse",
    opacity: 0.2,
    d: "M46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersect"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3696 34.9878C13.0757 32.7548 14.7491 30.9004 17.0001 30C21.4702 28.0843 26.5301 28.0843 31.0001 30C33.2512 30.9004 34.9246 32.7549 35.6307 34.988C32.7139 38.0743 28.582 40.0001 24.0002 40.0001C19.4184 40.0001 15.2865 38.0742 12.3696 34.9878Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 18C30.0001 21.3137 27.3138 24 24.0001 24C20.6864 24 18.0001 21.3137 18.0001 18C18.0001 14.6863 20.6864 12 24.0001 12C27.3138 12 30.0001 14.6863 30.0001 18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUserAccount);
export default __webpack_public_path__ + "static/media/ic_action_user_account.9724d6f9fe5af8b2faa1df02b3516440.svg";
export { ForwardRef as ReactComponent };